export enum RecipientTypeEnum {
  Individual = 'individual',
  Business = 'business',
}

export enum PaymentMethodTypeEnum {
  Card = 'card',
  BankAccount = 'bank_account',
}

export enum BankAccountTypeEnum {
  Checking = 'checking',
  Savings = 'savings',
}
